import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import { ButtonSizeTypes } from "@enums/button-size-types";
import styles from "./table-cell-with-button.less";

type TableCellWithButtonProps = {
    size: ButtonSizeTypes;
    variant: string;
    icon: IconDefinition;
    text: string;
    originalObject: any;
    id: string;
    onClick: (original: any) => void;
};

export const TableCellWithButton = (props: TableCellWithButtonProps) => {
    const { size, variant, icon, text, originalObject, id, onClick } = props;

    const handleOnClick = () => {
        onClick(originalObject);
    };

    return (
        <div className={styles.tableCellWithButton}>
            <Button id={id} size={size} variant={variant} onClick={handleOnClick}>
                <FontAwesomeIcon icon={icon} />
            </Button>
            {text && (
                <span>{text}</span>
            )}
        </div>
    );
};